import SimpleReasonDropdown from "./SimpleReasonDropdown/SimpleReasonDropdown";
import "./CreateLocalTrip.scss";

import FrontendFormValidationService from "../../../../../../frontend.services/FrontendFormValidation.service";
import InputCompositionContext from "../../../../../../hooks/useInputCompositionContext/useInputCompositionContext";
import {
    createLocalTripThunk,
    getLocalTripReasonsThunk,
} from "../../../../../../redux/actions/LocalTrips/thunk/LocalTrips.thunk.action";
import {
    clearLocalTripErrorAction,
    clearLocalTripReasonsAction,
    getErrorLocalTripAction,
    clearCreatedLocalTripAction, clearErrorLocalTripAction, // Добавьте этот action если его нет
} from "../../../../../../redux/actions/LocalTrips/LocalTrips.action";

import Breadcrumbs from "../../../../../common/Breadcrumbs/Breadcrumbs";
import IC from "../../../../../common/compositions/InputComposition/IC";

import OkButton from "../../../../../common/Button/OKButton/OKButton";
import Footer from "../../../../../layout/Footer/Footer";
import ModalBanOverlay from "../../../../../common/Modal/ModalBanOverlay/ModalBanOverlay";
import Header from "../../../../../layout/Header/Header";

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";

const CreateLocalTrip = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const reasonsList = useSelector(state => state.localTrips.localTripReasons);
    const error = useSelector(state => state.localTrips.localTripError);
    const createdTrip = useSelector(state => state.localTrips.createdLocalTrip);

    // State для контекста IC
    const [formState, setFormState] = useState({
        rules: {
            "reasonId": ["notEmpty"],
            "startsAtDate": ["notEmpty"],
            "startsAtTime": ["notEmpty"],
            // "endsAtDate": ["notEmpty"],
            "endsAtTime": ["notEmpty"],
        },
        reasonId: "",
        startsAtDate: "",
        startsAtTime: "",
        endsAtDate: "",
        endsAtTime: "",
        comment: "",
    });

    // State для отправки на сервер
    const [localTripState, setLocalTripState] = useState({
        reasonId: "",
        startsAtDate: "",
        startsAtTime: "",
        endsAtDate: "",
        endsAtTime: "",
        comment: "",
    });

    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [modalSuccess, setModalSuccess] = useState(false);
    const [notification, setNotification] = useState(false);
    const [fio] = useState(JSON.parse(localStorage.getItem("fio")));

    // Контекст использует formState для IC компонентов
    const context = [formState, setFormState, isError, setIsError];

    // Синхронизация formState с localTripState
    useEffect(() => {
        console.log("SYNC: formState → localTripState");
        setLocalTripState({
            reasonId: formState.reasonId || "",
            startsAtDate: formState.startsAtDate || "",
            startsAtTime: formState.startsAtTime || "",
            endsAtDate: formState.endsAtDate || "",
            endsAtTime: formState.endsAtTime || "",
            comment: formState.comment || "",
        });
    }, [formState]);

    function backButtonHandler() {
        navigate("/main/hr-services/work-time/local-trips");
    }

    // Функция для закрытия модального окна с очисткой
    const handleModalClose = () => {
        console.log("Closing modal and clearing form");

        // 1. Закрываем модальное окно
        setModalSuccess(false);

        // 2. Очищаем состояние формы
        setFormState({
            rules: {
                "reasonId": ["notEmpty"],
                "startsAtDate": ["notEmpty"],
                "startsAtTime": ["notEmpty"],
                "endsAtDate": ["notEmpty"],
                "endsAtTime": ["notEmpty"],
            },
            reasonId: "",
            startsAtDate: "",
            startsAtTime: "",
            endsAtDate: "",
            endsAtTime: "",
            comment: "",
        });

        // 3. Очищаем состояние для отправки
        setLocalTripState({
            reasonId: "",
            startsAtDate: "",
            startsAtTime: "",
            endsAtDate: "",
            endsAtTime: "",
            comment: "",
        });
        // 4. Сбрасываем ошибки
        setIsError(false);

        // 5. Очищаем уведомления
        setNotification(false);

        // 6. Сбрасываем состояние загрузки
        setIsLoading(false);

        // 7. Очищаем созданную командировку в Redux store
        dispatch(clearCreatedLocalTripAction());

        // 8. Очищаем ошибки в Redux store
        dispatch(clearLocalTripErrorAction());

        // 9. Переходим обратно к списку
        navigate("/main/hr-services/work-time/local-trips");
    };

    // Автоматически устанавливаем дату окончания = дате начала
    useEffect(() => {
        if (formState.startsAtDate ) {
            console.log("Auto-setting endsAtDate to:", formState.startsAtDate);
            setFormState(prev => ({
                ...prev,
                endsAtDate: prev.startsAtDate,
            }));
        }
    }, [formState.startsAtDate]);

    function submitHandler() {
        const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone ;
        console.log("userTimeZone",userTimeZone);
        // Проверяем через formState (там есть rules)
        const validation = new FrontendFormValidationService(
            formState,
            isError,
            setIsError,
            formState.rules
        );

        if (validation.validate()) {

            console.log("Validation passed. Sending:", localTripState);

            // Формируем даты в правильном формате (без миллисекунд и без Z)
            let startsAtFormatted, endsAtFormatted;

            try {
                // Объединяем дату и время
                const dateTimeString = `${localTripState.startsAtDate} ${localTripState.startsAtTime}`;
                console.log("Parsing startsAt string:", dateTimeString);

                const startsAtMoment = moment(dateTimeString, "YYYY-MM-DD HH:mm");

                if (!startsAtMoment.isValid()) {
                    console.error("Invalid startsAtMoment:", startsAtMoment);
                    throw new Error("Некорректная дата начала");
                }

                // Форматируем в нужный формат: 2024-01-15T09:00:00
                startsAtFormatted = startsAtMoment.format("YYYY-MM-DDTHH:mm:ss");
                console.log("startsAtFormatted:", startsAtFormatted);

            } catch (error) {
                console.error("Error parsing startsAt:", error);
                dispatch(getErrorLocalTripAction({
                    message: "Ошибка в дате начала. Проверьте формат даты и времени.",
                }));
                // setNotification(true);
                return;
            }

            try {
                const dateTimeString = `${localTripState.endsAtDate} ${localTripState.endsAtTime}`;
                console.log("Parsing endsAt string:", dateTimeString);

                const endsAtMoment = moment(dateTimeString, "YYYY-MM-DD HH:mm");

                if (!endsAtMoment.isValid()) {
                    console.error("Invalid endsAtMoment:", endsAtMoment);
                    dispatch(getErrorLocalTripAction({
                        message: "Некорректная дата окончания",
                    }));
                }

                // Форматируем в нужный формат: 2024-01-15T09:00:00
                endsAtFormatted = endsAtMoment.format("YYYY-MM-DDTHH:mm:ss");
                console.log("endsAtFormatted:", endsAtFormatted);

            } catch (error) {
                console.error("Error parsing endsAt:", error);
                dispatch(getErrorLocalTripAction({
                    message: "Ошибка в дате окончания. Проверьте формат даты и времени.",
                }));
                // setNotification(true);
                return;
            }

            // Дополнительная валидация: конец должен быть после начала
            const startsAtMoment = moment(startsAtFormatted);
            const endsAtMoment = moment(endsAtFormatted);


            if (endsAtMoment.isSameOrBefore(startsAtMoment)) {
                dispatch(getErrorLocalTripAction({
                    message: "Время окончания должно быть позже времени начала.",
                }));
                // setNotification(true);
                return;
            }

            // Проверка необходимости комментария для выбранной причины
            if (reasonsList && reasonsList.length > 0) {
                const selectedReason = reasonsList.find(
                    reason => reason.value === localTripState.reasonId
                );

                if (selectedReason) {
                    console.log("Selected reason:", selectedReason);

                    // Проверка необходимости комментария
                    if (selectedReason.commentRequired &&
                        (!localTripState.comment || localTripState.comment.trim() === "")) {
                        dispatch(getErrorLocalTripAction({
                            message: `Для причины "${selectedReason.displayName}" требуется комментарий.`,
                        }));
                        // setNotification(true);
                        return;
                    }
                }
            }

            // Формируем объект для отправки согласно спецификации API
            const tripData = {
                startsAt: startsAtFormatted, // Используем отформатированную дату
                endsAt: endsAtFormatted, // Используем отформатированную дату
                reason: localTripState.reasonId, // Используем value из выпадающего списка
                comment: localTripState.comment || "",
                timeZoneId: userTimeZone,
            };

            console.log("Final tripData object:");
            console.log(JSON.stringify(tripData, null, 2));

            // Проверяем формат перед отправкой
            const formatRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/;
            if (!formatRegex.test(startsAtFormatted) || !formatRegex.test(endsAtFormatted)) {
                console.error("Invalid date format!");
                console.log("startsAtFormatted:", startsAtFormatted, "matches?", formatRegex.test(startsAtFormatted));
                console.log("endsAtFormatted:", endsAtFormatted, "matches?", formatRegex.test(endsAtFormatted));
                dispatch(getErrorLocalTripAction({
                    message: "Неверный формат даты. Пожалуйста, проверьте введенные данные.",
                }));
                // setNotification(true);
                return;
            }
            setIsLoading(true)
            dispatch(createLocalTripThunk(tripData, { setIsLoading:setIsLoading, setModalSuccess: setModalSuccess }));
        } else {
            console.log("Validation failed");
            dispatch(getErrorLocalTripAction({
                message: "Пожалуйста, заполните все обязательные поля.",
            }));
            // setNotification(true);
        }
    }

    function closeNotificationHandler() {
        dispatch(clearLocalTripErrorAction());
        setNotification(false);
    }

    useEffect(() => {
        // Сбрасываем все состояния при открытии формы
        dispatch(clearCreatedLocalTripAction());
        dispatch(clearLocalTripErrorAction());

        // Загружаем причины
        dispatch(getLocalTripReasonsThunk());

        return () => {
            dispatch(clearLocalTripReasonsAction());
        };
    }, [dispatch]);

    // Обработка успешного создания командировки
    useEffect(() => {
        if (createdTrip) {
            setModalSuccess(true);
        }
        return () => {
            if (createdTrip) {
                dispatch(clearCreatedLocalTripAction());
            }
        };
    }, [createdTrip]);
    console.log(createdTrip);
    // Минимальное время для окончания
    const getMinEndTime = () => {
        if (formState.startsAtTime && formState.startsAtDate === formState.endsAtDate) {
            return formState.startsAtTime;
        }
        return null;
    };

    useEffect(() => {
        return () => {
            dispatch(clearErrorLocalTripAction());
        };
    }, []);

    return (
        <>
            <Header />
            <Breadcrumbs />
            <main
                className={"create-local-trip"}
                style={{ minHeight: "35vh", width: "1160px", margin: "0 auto", position: "relative", display: "flex", flexDirection: "column" }}
            >
                <h3 className={"sub-header"} style={{ alignSelf: "flex-start", marginBottom: "44px" }}>
                    Создание местной командировки/отсутствия
                </h3>

                <div className={"user-info"}>
                    <div className={"user-info__item"}>
                        <span className={"user-info__label"}>ФИО инициатора заявки*</span>
                        <span className={"user-info__value"}>
                            {fio.lastNameRu}
                            <br />
                            {fio.firstNameRu}
                            {" "}
                            {fio.secondNameRu}
                        </span>
                    </div>
                </div>

                <InputCompositionContext.Provider value={context}>
                    {/* Причина отсутствия */}
                    <IC field={"reasonId"} require>
                        <IC.Label value={"Причины отсутствия"} />
                        <IC.Input />
                        <IC.Error />
                        <IC.Dropdown>
                            <SimpleReasonDropdown items={reasonsList} />
                        </IC.Dropdown>
                    </IC>

                    {/* Комментарий */}
                    <IC field={"comment"}>
                        <IC.Label value={"Комментарий для руководителя"} />
                        <IC.Input />
                        <IC.Description value={"Укажите причину командировки"} />
                    </IC>

                    {/* Даты и время */}
                    <div className={"date-time-container"}>
                        {/* Дата начала */}
                        <div className={"date-time-group"}>
                            <IC field={"startsAtDate"} customStyle={"datepicker"} require>
                                <IC.Label value={"Дата начала отсутствия"} />
                                <IC.DatepickerSelect
                                    minDate={new Date()}
                                />
                                <IC.Error />
                            </IC>

                            <IC field={"startsAtTime"} require>
                                <IC.Label value={"Время начала отсутствия"} />
                                <IC.TimePickerSelect
                                    field="startsAtTime"
                                    placeholder="Выберите время"
                                    timeIntervals={5}
                                    // Передаем поле с датой для проверки "сегодняшний день"
                                    dateField="startsAtDate"
                                    // Можно также указать явный minTime если нужно
                                    // minTime="08:00"
                                />
                                {/*<IC.Error />*/}
                                <IC.Description value={"Формат: ЧЧ:MM (например, 09:00)"} />
                            </IC>
                        </div>

                        {/* Дата окончания */}
                        <div className={"date-time-group"}>
                            <IC field={"endsAtDate"} customStyle={"datepicker"} require >
                                <IC.Label value={"Дата возвращения на работу"} />
                                <IC.Input
                                    disabled={true}
                                    value={formState.endsAtDate ?
                                        moment(formState.endsAtDate).format("DD.MM.YYYY") :
                                        "Будет установлена автоматически"}
                                />
                                <IC.Error />
                            </IC>

                            <IC field={"endsAtTime"} require>
                                <IC.Label value={"Время возвращения на работу"} />
                                <IC.TimePickerSelect
                                    field="endsAtTime"
                                    placeholder="Выберите время"
                                    timeIntervals={5}
                                    dateField="endsAtDate" // используем дату окончания
                                    minTime={getMinEndTime()}
                                    // Если нужно, чтобы время окончания было не раньше времени начала
                                    // minTime={formState.startsAtDate === formState.endsAtDate ? formState.startsAtTime : null}
                                />
                                {/*<IC.Error />*/}
                                <IC.Description value={"Формат: ЧЧ:MM (например, 18:00)"} />
                            </IC>
                        </div>
                    </div>
                </InputCompositionContext.Provider>

                <div
                    style={{
                        width: "1160px",
                        margin: "60px auto",
                        display: "flex",
                        justifyContent: "space-between",
                    }}
                >
                    <OkButton title={"назад"} handler={backButtonHandler} />
                    <OkButton
                        onValidation={isLoading}
                        title={"направить"}
                        handler={submitHandler}
                    />
                </div>

                {error ? (
                    <div className={"create-local-trip__notification"}>
                        <div
                            onClick={closeNotificationHandler}
                            className={"create-local-trip__notification__cross"}
                        ></div>
                        <p>{error?.message || "Произошла ошибка"}
                        </p>
                    </div>
                ) : null}
            </main>
            <Footer />

            <ModalBanOverlay shown={modalSuccess} onClose={handleModalClose}>
                <div className={"delegation-modal-status"}>
                    <div className={"delegation-modal-status__header sub-header"}>
                        Заявка создана успешно
                    </div>
                    <div className={"delegation-modal-status__content"}>
                        Ваш запрос на местную командировку отправлен на согласование
                        <br />
                        <br />
                        <div>
                            Период:{" "}
                            <span className={"delegation-modal-status__content__highlight"}>
                                {localTripState.startsAtDate &&
                                    moment(localTripState.startsAtDate).format("DD.MM.YYYY")}{" "}
                                {localTripState.startsAtTime || ""}
                            </span>
                            {" - "}
                            <span className={"delegation-modal-status__content__highlight"}>
                                {localTripState.endsAtDate &&
                                    moment(localTripState.endsAtDate).format("DD.MM.YYYY")}{" "}
                                {localTripState.endsAtTime || ""}
                            </span>
                        </div>
                    </div>
                    <div className={"delegation-modal-status__buttons"}>
                        <OkButton title={"ок"} handler={handleModalClose} />
                    </div>
                </div>
            </ModalBanOverlay>
        </>
    );
};

export default CreateLocalTrip;
